export default __webpack_public_path__ + "static/media/ic-excluded.062ac507.svg";